export function printFileByByteArray(data,  fileExtension) {
  const blob = new Blob([data], { type: fileExtension })
  var blobURL = URL.createObjectURL(blob);
  
  var iframe =  document.createElement('iframe'); 
  document.body.appendChild(iframe);

  iframe.style.display = 'none';
  iframe.src = blobURL;
  iframe.onload = function() {
    setTimeout(function() {
      iframe.focus();
      iframe.contentWindow.print();
    }, 1);
  };
}
